import { configureStore } from "@reduxjs/toolkit";

import mainSystemLoaderReducer from "../reducers/system_loaders/main_system_loader_Slice";

// Store For All Reducers
export const system_loaders_store = configureStore({
 reducer: {
  // Main
  main_system_loader: mainSystemLoaderReducer
 }
});